export class BalloonForVLP {
    constructor(app) {
        this.app = app;
        this.vehicle = null;
    }

    async getPixelMotionAPR(successCallback) {
        let vehicle = this.getVehicle();
        // console.log(vehicle);
        let pmdrs = this.app.pmdrs;
        let sc = (response) => {
            if (response) {
                let apr = JSON.parse(response);
                // console.log(apr);
                let termsLength = Object.keys(apr.balloon.ratings[0].terms).length;
                let paymentData = {
                    cashDown: 0,
                    creditRating: apr.balloon.ratings[0].label,
                    creditRatingKey: apr.balloon.creditScore[0].max,
                    loanMonths: Object.keys(apr.balloon.ratings[0].terms)[termsLength - 1],
                    tradeInData: {
                        tradeInEstimate: 0,
                    },
                    mileageAllowance: 0,
                };
                let balloonAPR = this.getBalloonAPR(paymentData.creditRating, paymentData.loanMonths, apr);
                let creditScoreAPR = this.getBalloonCreditScoreAPR(
                    paymentData.creditRating,
                    paymentData.loanMonths,
                    apr
                );
                let paymentObject = {
                    moneyFactor: "",
                    monthlyPayment: "",
                    totalPayments: "",
                    downPayment: 0,
                    term: paymentData.loanMonths,
                    expirationDate: "",
                    ratingBalloonAPR: creditScoreAPR,
                };
                let balloon = this.getPaymentData(balloonAPR, creditScoreAPR, paymentObject);
                if (successCallback) {
                    successCallback(balloon);
                }
            }
        };

        //ERROR
        let ec = () => {
            console.log("Error getting OfferlogixDriver config");
        };
        pmdrs.pmApi.getPixelmotionAPR("bmwmotorrad", vehicle.siteToken, vehicle.vin, sc, ec);
    }

    getBalloonAPR(rating, months, apr) {
        let balloon = apr.balloon.balloon[0];
        let rate = parseFloat(balloon["Easy Ride"][months]);
        return rate;
    }

    getBalloonCreditScoreAPR(rating, months, apr) {
        let creditScore = apr.balloon.ratings.find((elem) => elem.label === rating);
        return creditScore.terms[months];
    }

    getPaymentData(ballonAPR, creditScoreAPR, paymentObject) {
        let totalAmount = this.getVehicle().finalPrice;
        let apr = {
            ballonAPR: ballonAPR / 100,
            ratingAPR: creditScoreAPR / 100,
        };
        let payment = this.calculateBalloonPayment(totalAmount, apr.ballonAPR);
        return this.calculateMonthlyPaymentBalloon(payment, apr.ratingAPR, totalAmount, paymentObject.term);
    }

    calculateBalloonPayment(totalAmount, balloonAPR) {
        return totalAmount * balloonAPR;
    }

    calculateMonthlyPaymentBalloon(payment, ratingAPR, totalAmount, months) {
        ratingAPR = ratingAPR / 12;
        let balloon = {};
        let firstStep = totalAmount - payment / Math.pow(1 + ratingAPR, months);
        let secondStep = ratingAPR / (1 - Math.pow(1 + ratingAPR, months * -1));
        let monthly = firstStep * secondStep;
        return (balloon = {
            balloonPayment: payment.toFixed(2),
            monthly: monthly.toFixed(2),
            term: months,
        });
    }

    setVehicle(vehicle) {
        this.vehicle = vehicle;
    }

    getVehicle() {
        return this.vehicle;
    }
}
